"use client"

import { useState } from "react"
import Modal from "./Modal"
import "../styles/Header.css"

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <>
      <header className="header">
        <div className="header-container">
          <div className="logo">Ashtech Presidential</div>

          <nav className={`nav ${isMenuOpen ? "active" : ""}`}>
            <a href="#about">About Us</a>
            <a href="#highlights">Highlights</a>
            <a href="#amenities">Amenities</a>
            <a href="#price">Price</a>
            <a href="#floorplan">Floor Plan</a>
            <a href="#location">Location Map</a>
            <a href="#gallery">Gallery</a>
          </nav>

          <div className="header-right">
            {!isMenuOpen && (
              <div className="phone-btn">
                <span className="phone-icon">📞</span>
                +91 8800313885
              </div>
            )}
            <button className="menu-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
              ☰
            </button>
          </div>
        </div>
      </header>
    
        <div className="sticky-nav-buttons">
          <button
            className="nav-btn enquire-btn"
            onClick={() => setIsModalOpen(true)}
          >
            Enquire Now
          </button>
          <button
            className="nav-btn whatsapp-btn"
            onClick={() => window.open("https://wa.me/918800313885", "_blank")}
          >
            WhatsApp
          </button>
          <button
            className="nav-btn call-btn"
            onClick={() => window.open("tel:+918800313885")}
          >
            Call Now
          </button>
        </div>

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  )
}
